import React, { Component } from 'react';

import './aboutPage.scss';

export default class AboutPage extends Component<{}, {}> {
  render() {
    return (
      <div className='about-page container'>
        <h2 className='page__title'>About us</h2>
      </div>
    );
  }
}
